import React, { useMemo } from 'react'

import { LntModal } from '@app/components/base'
import { LabelValueTable } from '@app/components'

import { getLabelValueDataFromSummary } from './utils'

import type { RegistryTotalModalProps } from './types'

export const RegistryTotalModal: React.FC<RegistryTotalModalProps> = ({ summaryEntity, ...modalProps }) => {
  const tableData = useMemo(() => summaryEntity && getLabelValueDataFromSummary({ ...summaryEntity }), [summaryEntity])

  return (
    <LntModal
      { ...modalProps }
      footer={ null }
    >
      <LabelValueTable data={ tableData } />
    </LntModal>
  )
}
